import { createInertiaApp } from '@inertiajs/react'
import '../styles/application.css'
import { installBugBuffer } from '../lib/bugContext'

// Install the in-house bug-report buffer (replaces the former third-party
// BoostToad widget). Captures recent client errors + failed network metadata
// for attachment to bug submissions from the Help modal. Idempotent + privacy-
// safe; see app/frontend/lib/bugContext.js. Installed before app boot so
// early errors are captured.
installBugBuffer()

createInertiaApp({
  pages: "../pages",

  strictMode: true,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
      "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
      'Consider moving <%= vite_javascript_tag "inertia.jsx" %> to the Inertia-specific layout instead.',
    )
  }
})
